import PropTypes from 'prop-types';
export var bubbleType = {
  SENDER: 'sender',
  RECEIVER: 'receiver'
};
export var bubbleContentType = {
  TEXT: 'text',
  MIDIA: 'midia'
};
export var bubbleTypePropType = PropTypes.oneOf(Object.values(bubbleType));
export var bubbleContentTypePropType = PropTypes.oneOf(Object.values(bubbleContentType));